import { render, staticRenderFns } from "./trafficView.vue?vue&type=template&id=cb0ac574&scoped=true&"
import script from "./trafficView.vue?vue&type=script&lang=js&"
export * from "./trafficView.vue?vue&type=script&lang=js&"
import style0 from "./trafficView.vue?vue&type=style&index=0&id=cb0ac574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0ac574",
  null
  
)

component.options.__file = "trafficView.vue"
export default component.exports